import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ResultHeader from "../resultPage/ResultHeader";
import { Box, Typography } from "@material-ui/core";
import Filters from "./Filters";
// import useFetch from "../../hooks/useFetch";
// import { getStudentExamAnalysis } from "../../apis/resultService";
import calculateDates from "../../utils/caluculateDateRanges";
import store from "store";
import NetworkProgress from "../NetworkProgress";
import { groupBy } from "lodash";
import ColumnChart from "./columnChart";
import NoResultMsg from "../resultPage/NoResultMsg";
import AbsenteesAnalysis from "./absenteesAnalysis";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import {
  fetchExamAnalysis,
  clearExamAnalysis,
} from "../../redux/actions/analysisPageActions/actionCreators";
import SkeletonLoader from "./skeletonLoader";

const ExamAnalysis = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const user = store.get("user");

  const analysisData = useSelector((state) => state.examAnalysis);

  const query = new URLSearchParams(location.search);
  const level = query.get("level");
  const account = query.get("accountType");
  const userLevel = level || (user && user.level);
  const accountType = account || (user && user.accountType);
  const student_id = user && user.accountType ? user.studentIds : user._id;
  const [selectedDateValue, setSelectedDateValue] = useState("last4Exams");
  const [selectedExams, setSelectedExams] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [finalData, setFinalData] = useState([]);
  const [selectedExamType, setSelectedExamType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [groupedChartData, setGroupedChartData] = useState({});
  const [totalLengthGroupData, setTotalLengthGroupData] = useState({});
  const [totalWrittenGroupData, setTotalWrittenGroupData] = useState({});
  const [processedAverages, setProcessedAverages] = useState([]);
  const [examTypeOptions, setExamTypeOptions] = useState([]);
  const [isAbsent, setIsAbsent] = useState(false);
  const isMounted = useRef(true);
  const [toggleState, setToggleState] = useState([]);
  const [hasData, setHasData] = useState(false);

  // const [isLoading, err, analysisData, getAnalysis, reset] = useFetch(
  //   getStudentExamAnalysis
  // );

  const handleDateChange = (value) => {
    setHasData(false);
    setSelectedDateValue(value);
    setSelectedExams([]);
  };

  const handleExamsChange = (value) => {
    setHasData(false);
    if (Array.isArray(value)) {
      setSelectedExams(value);
    } else {
      const currentIndex = selectedExams.indexOf(value);
      const newChecked = [...selectedExams];
      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setSelectedExams(newChecked);
    }
  };

  const handleExamTypeChange = (value) => {
    setHasData(false);
    setSelectedExamType(value);
    setSelectedExams([]);
  };

  const handleFromDateChange = (date) => setFromDate(date);

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const handleToggleChange = (event, newState) => {
    setToggleState(newState || []);
    setIsAbsent(newState.includes("absent"));
    setIsChecked(newState.includes("average"));
  };

  const processAveragesData = (averages) => {
    if (!averages || averages.length === 0) return [];

    return averages.map((test) => ({
      result: { ...test },
      testDisplayName: `Average | Attempted Exams: ${
        test.ATT && test.ATT.includes("|")
          ? test.ATT.replace(/\|/g, "/")
          : test.ATT || "N/A"
      }`,
      test_type: test.test_type,
      isAverage: true,
    }));
  };

  const payload = () => {
    let dates = JSON.stringify({});
    let examsCount = "";
    if (fromDate && toDate) {
      dates = { startDate: fromDate, endDate: toDate };
    } else if (selectedDateValue) {
      if (selectedDateValue === "customRange") {
        dates = calculateDates(selectedDateValue);
      } else {
        switch (selectedDateValue) {
          case "last1Exams":
            examsCount = "1_exams";
            break;
          case "last4Exams":
            examsCount = "4_exams";
            break;
          case "last8Exams":
            examsCount = "8_exams";
            break;
          case "last16Exams":
            examsCount = "16_exams";
            break;
          case "last20Exams":
            examsCount = "20_exams";
            break;
          case "tillNow":
            examsCount = "all";
            break;
          default:
            examsCount = "4_exams";
        }
      }
    } else {
      dates = JSON.stringify({});
    }
    const payload = {
      dates,
      examtype: selectedExamType,
      avg: isChecked,
      student_id,
      selected_exams: selectedExams,
      examsCount,
    };
    dispatch(fetchExamAnalysis(payload));
    //getAnalysis(payload);
  };

  useEffect(() => {
    if (!hasData) {
      payload();
    }
  }, [
    isChecked,
    selectedExamType,
    fromDate,
    toDate,
    selectedDateValue,
    selectedExams,
  ]);

  useEffect(() => {
    if (
      analysisData &&
      !analysisData.isLoading &&
      analysisData.output &&
      isMounted.current
    ) {
      const results = analysisData.output.results || [];
      const latestExams = results
        .slice()
        .sort((a, b) => new Date(b.startDateTime) - new Date(a.startDateTime))
        .map((exam) => exam.test_name);

      setSelectedExams(latestExams);
      setHasData(true);
      isMounted.current = false;
    }
  }, [analysisData, analysisData.isLoading]);

  useEffect(() => {
    if (
      analysisData &&
      !analysisData.isLoading &&
      analysisData.output &&
      analysisData.output.results &&
      selectedExams.length === 0 &&
      !isMounted.current
    ) {
      const results = analysisData.output.results || [];

      const latestExams = results
        .slice()
        .sort((a, b) => new Date(b.startDateTime) - new Date(a.startDateTime))
        .map((exam) => exam.test_name);

      setSelectedExams(latestExams);
      setHasData(true);
    }
  }, [analysisData, analysisData.isLoading]);

  useEffect(() => {
    if (
      analysisData &&
      analysisData.writtenExamTypes &&
      Array.isArray(analysisData.writtenExamTypes)
    ) {
      setExamTypeOptions([...analysisData.writtenExamTypes]);
    }
  }, [analysisData]);

  useEffect(() => {
    if (analysisData && analysisData.output && analysisData.output.results) {
      const data = analysisData.output.results;
      const filteredData =
        selectedExams.length > 0
          ? data.filter((item) => selectedExams.includes(item.test_name))
          : data;

      setFinalData(filteredData);

      const groupedByTestType = groupBy(filteredData, "test_type");
      setGroupedChartData(groupedByTestType);
      const totalGrouped = groupBy(data, "test_type");
      const perTestTypeCount = Object.entries(totalGrouped).reduce(
        (acc, [testType, exams]) => {
          acc[testType] = exams.length;
          return acc;
        },
        {}
      );

      const resultCountsByTestType = {};

      Object.entries(totalGrouped).forEach(([testType, tests]) => {
        const count = tests.filter(
          (test) => test.result && test.result !== "NA"
        ).length;
        resultCountsByTestType[testType] = count;
      });
      /*--- DISPLAYING WRITTEN EXAMS LENGTH ---*/
      setTotalWrittenGroupData(resultCountsByTestType);
      /*--- DISPLAYING TOTAL EXAMS LENGTH ---*/
      setTotalLengthGroupData(perTestTypeCount);
    }
  }, [analysisData, selectedExams]);

  // Process averages data when analysis data changes
  useEffect(() => {
    if (analysisData && analysisData.output && analysisData.output.averages) {
      const processed = processAveragesData(analysisData.output.averages);
      setProcessedAverages(processed);
    }
  }, [analysisData]);
  

  if (
    [
      "211210",
      "2119710",
      "X0210767",
      "X0210766",
      "X0210765",
      "X0210764",
    ].includes(`${userLevel}`) &&
    accountType !== "parent"
  )
    return <NoResultMsg header />;

  return (
    <>
      {analysisData.isLoading ? (
        // <Box display="flex" justifyContent="center" style={{ height: "50vh" }}>
        //  <NetworkProgress />
        // </Box>
       
          <SkeletonLoader />
      ) : (
        <div>
          <ResultHeader testDisplayName="Analysis" path="/home-page" />
          {analysisData &&
          !analysisData.isLoading &&
          analysisData.output &&
          analysisData.output.results &&
          analysisData.output.results[0] === null ? (
            <Typography align="center" color="error">
              Analysis not available, please select a different set of filters.
            </Typography>
          ) : null}

          {finalData.length > 0 ? (
            <>
              <ToggleButtonGroup
                value={toggleState}
                onChange={handleToggleChange}
                aria-label="absent average toggle"
                size="small"
                style={{
                  paddingRight: "16px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <ToggleButton
                  value="absent"
                  aria-label="absent"
                  style={{
                    fontWeight: "bold",
                    "&.Mui-selected": {
                      backgroundColor: " #1976d2",
                      color: "white",
                    },
                  }}
                >
                  Absent
                </ToggleButton>
                <ToggleButton
                  value="average"
                  aria-label="average"
                  style={{
                    fontWeight: "bold",
                    "&.Mui-selected": {
                      backgroundColor: " #1976d2",
                      color: "white",
                    },
                  }}
                >
                  Average
                </ToggleButton>
              </ToggleButtonGroup>
              <br />
              {isAbsent ? (
                <AbsenteesAnalysis analysisData={analysisData} />
              ) : (
                Object.entries(groupedChartData).map(([testType, data]) => {
                  const typeWiseDataCount = data.filter(
                    (test) => test.result && test.result !== "NA"
                  ).length;

                  const enableAverage =
                    groupedChartData[testType].length > 1 &&
                    typeWiseDataCount > 1;

                  const testTypeAverages = enableAverage
                    ? processedAverages.filter(
                        (avg) => avg.test_type === testType
                      )
                    : [];

                  return (
                    <Box
                      px={2}
                      display="flex"
                      flexDirection="column"
                      key={testType}
                      my={1}
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography
                          variant="h6"
                          color="primary"
                          style={{ fontWeight: "bold" }}
                        >
                          {testType}
                        </Typography>
                      </Box>
                      <ColumnChart
                        subjects={analysisData.output.subjects || []}
                        data={isChecked ? [...data, ...testTypeAverages] : data}
                        checkedCount={`${totalWrittenGroupData[testType] ||
                          0}/${totalLengthGroupData[testType] || 0}`}
                      />
                    </Box>
                  );
                })
              )}
            </>
          ) : (
            !analysisData.isLoading && (
              <Typography align="center" color="error">
                Exams not available
              </Typography>
            )
          )}
        </div>
      )}
      <br />
      <Box
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: "16px",
        }}
      >
        <Filters
          selectedDateValue={selectedDateValue || ""}
          selectedExams={selectedExams || []}
          onDateChange={handleDateChange}
          onExamsChange={handleExamsChange}
          onExamTypeChange={handleExamTypeChange}
          selectedExamType={selectedExamType || ""}
          examTypeOptions={examTypeOptions || []}
          exams={
            (analysisData &&
              analysisData.output &&
              analysisData.output.results) ||
            []
          }
          fromDate={fromDate}
          toDate={toDate}
          onFromDateChange={handleFromDateChange}
          onToDateChange={handleToDateChange}
        />
      </Box>
    </>
  );
};

export default ExamAnalysis;
